// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__3Ve2A","contentContainer":"styles_contentContainer__Co7Qh"};